import React, { useEffect } from "react";
import { useForm } from "react-hook-form";
import { Button, Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";

import { useAction } from "../../../../hooks/actions";
import FormItem from "../../../components/FormItem";
import { WarningValidationForm } from "../../../components/Notifications";
import { basicInformationConfig } from "../form-config";
import { DEFAULT_VALUE } from "../constants";
import { useAddNewUserMutation } from "../../../../middleware/usersApi";
import { formatPhoneNumber } from "../helpers";
import { PATHS } from "../../../../constants";
import { useAppSelector } from "../../../../hooks/redux";
export const AddEmployee = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { token } = useAppSelector((state) => state.users);
  const { setIsErrorSubmit, setIsSuccessSubmit } = useAction();
  const [addEmployee, { error: errorAdd, isSuccess: isSuccessAdd, isLoading }] = useAddNewUserMutation();

  const {
    control,
    handleSubmit,
    formState: { errors, isSubmitSuccessful },
  } = useForm({
    mode: "onChange",
    defaultValues: DEFAULT_VALUE,
  });
  const isWarningValidation = !!Object.keys(errors).length;
  const error = errorAdd;
  const isSuccess = isSuccessAdd;

  const onSubmit = async (data) => {
    const { fullName } = data || {};

    const fio = fullName.split(" ");
    const firstName = fio[1] || "";
    const surname = fio[2] || "";
    const lastName = fio[0] || "";

    const requestData = {
      phoneNumber: formatPhoneNumber(data.phoneNumber),
      login: data.login,
      email: "",
      password: data.password,
      PasswordRepeat: data.password,
      firstName: firstName,
      roleId: data.roleId,
      surname: surname,
      lastName: lastName,
    };
    if (data.subdivisionId) {
      requestData.subdivisionId = data.subdivisionId;
    }

    addEmployee({ token, data: requestData }).then((result) => {
      if ("error" in result) {
        return;
      }
      navigate(PATHS.LIST_EMPLOYEES);
    });
  };

  const handleCancel = () => navigate(-1);

  useEffect(() => {
    setIsErrorSubmit(error);
  }, [error]);

  useEffect(() => {
    setIsSuccessSubmit(isSuccess);
  }, [isSuccess]);

  return (
    <Box className="template_page employee">
      <Box className="template_page-header">
        <Typography className="title-page">{t("title_page:add_employee")}</Typography>
        <Box className="template_page-header-buttons">
          <Button className="btn btn-white" onClick={handleCancel}>
            {t("button:comeback")}
          </Button>
          <Button
            form="myform"
            className="btn btn-primary-fill"
            type="submit"
            disabled={(isSubmitSuccessful && !error) || isLoading}
          >
            {t("button:save")}
          </Button>
        </Box>
      </Box>
      <form className="scrolled-form" id="myform" onSubmit={handleSubmit(onSubmit)}>
        <Box className="basic_form">
          <Box className="content">
            {basicInformationConfig.map(({ id, name, label, rules, input, ...rest }) => (
              <FormItem key={id} control={control} errors={errors} name={name} label={label} input={input} {...rest} />
            ))}
          </Box>
        </Box>
      </form>

      {isWarningValidation && <WarningValidationForm isWarning={isWarningValidation} />}
    </Box>
  );
};
